import React from 'react'
import styles from './Navigator.module.css';
import userIcon from '../../assets/Home/userIcon.svg';
import depIcon from '../../assets/Home/DepartamentIcon.svg';
import bellIcon from '../../assets/Home/bellIcon.svg';
import iIcon from '../../assets/Home/iIcon.svg';
import keyIcon from '../../assets/Home/key.svg';
import customersIcon from '../../assets/Home/customersIcon.svg';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

function Navigator() {
    const navigate = useNavigate();
    const { user } = useAuth(); // Assuming NemuContext is used for user context
    console.log(user);

  return (
    <div className={`sticky top-[112px] h-[60svh] z-50 ${styles['container-nav']}`}>
      <NavLink to='/profile' className={({ isActive }) => `flex justify-center items-center w-full aspect-square rounded-[6px] transition-all duration-300 hover:bg-black hover:[&_img]:invert ${isActive ? 'bg-black [&_img]:invert' : ''}`} >
        <img src={userIcon} alt="User Icon" />
      </NavLink>
      <NavLink to='/myprojects' className={({ isActive }) => `flex justify-center items-center w-full aspect-square rounded-[6px] transition-all duration-300 hover:bg-black hover:[&_img]:invert ${isActive ? 'bg-black [&_img]:invert' : ''}`}>
        <img src={depIcon} alt="departament Icon" />
      </NavLink>
      <NavLink to='/notifications' className={({ isActive }) => `flex justify-center items-center w-full aspect-square rounded-[6px] transition-all duration-300 hover:bg-black hover:[&_img]:invert ${isActive ? 'bg-black [&_img]:invert' : ''}`}>
        <img src={bellIcon} alt="bell Icon" />
      </NavLink>
      <NavLink to='/terms-and-conditions' className={({ isActive }) => `flex justify-center items-center w-full aspect-square rounded-[6px] transition-all duration-300 hover:bg-black hover:[&_img]:invert ${isActive ? 'bg-black [&_img]:invert' : ''}`}>
        <img src={iIcon} alt="i Icon" />
      </NavLink>
      {user && user.role === 'admin' && 
        <NavLink to='/access-key' className={({ isActive }) => `flex justify-center items-center w-full aspect-square rounded-[6px] transition-all duration-300 hover:bg-black hover:[&_img]:invert ${isActive ? 'bg-black [&_img]:invert' : ''}`}>
          <img src={keyIcon} className='w-6' alt="Key Icon" />
        </NavLink>
      }
      {user && user.role === 'admin' &&
        <NavLink to='/language-check' className={({ isActive }) => `flex justify-center items-center w-full aspect-square rounded-[6px] transition-all duration-300 hover:bg-black hover:[&_img]:invert ${isActive ? 'bg-black [&_img]:invert' : ''}`}>
          <img src={keyIcon} className='w-6' alt="Key Icon" />
        </NavLink>
      }
      {user && user.role === 'admin' &&
        <NavLink to='/customers' className={({ isActive }) => `flex justify-center items-center w-full aspect-square rounded-[6px] transition-all duration-300 hover:bg-black hover:[&_img]:invert ${isActive ? 'bg-black [&_img]:invert' : ''}`}>
          <img src={customersIcon} className='w-6' alt="Clientes" />
        </NavLink>
      }
    </div>
  )
}

export { Navigator }; 